import { unref, computed } from 'vue'

/**
 * ユーザーリスト表示項目(センサー)の利用
 * @param {MaybeRef.<string>} sensorItemName センサー測定項目名
 * @param {MaybeRef.<number>} value センサー値
 * @param {MaybeRef.<string>} unit 単位
 * @param {MaybeRef.<Array>} valueType センサー値コード定義
 */
export function useUserStatusAdditionalItemSensorData({
  sensorItemName,
  value,
  unit,
  valueType,
}) {
  /**
   * センサー値が連続値でない場合はtrue
   * @type {ComputedRef.<boolean>}
   */
  const isDiscrete = computed(() => {
    const vType = unref(valueType)
    return Array.isArray(vType) && !!vType.length
  })

  /**
   * 単位表示できる場合はtrue
   * @type {ComputedRef.<boolean>}
   */
  const canShowUnit = computed(() => !isDiscrete.value && unref(unit))

  /**
   * 値コードMap
   * @type {ComputedRef.<Map>}
   */
  const valueCodeMap = computed(() => {
    if (!isDiscrete.value) return null
    return new Map(unref(valueType).map((type) => [type.value, type.text]))
  })

  /**
   * センサー値表示テキスト
   * @type {ComputedRef.<string>}
   */
  const valueText = computed(() => {
    const v = unref(value)
    const itemName = unref(sensorItemName)
    if (v == null || !itemName) return '-'
    return isDiscrete.value ? valueCodeMap.value.get(v) || '-' : v
  })

  /**
   * センサー表示テキスト
   * @type {ComputedRef.<string>}
   */
  const text = computed(() => {
    const itemNameText = unref(sensorItemName) || ''
    const unitText = unref(unit) || ''
    return canShowUnit.value
      ? `${valueText.value} ${unitText} (${itemNameText})`
      : `${valueText.value} (${itemNameText})`
  })

  return { text, valueText, isDiscrete, canShowUnit, valueCodeMap }
}
